export default __webpack_public_path__ + "static/media/Monster 404 Error-cuate.09cacfc8.png";